import { readIsChecked } from '../../field-viewer/prehydration-readers';
import { acceptBooleanValue } from '../../field-viewer/shared-normalizers';
export const ecomSubscriptionCheckboxViewer = {
    normalizeLoadedValue: acceptBooleanValue,
    readPrehydrationValue: readIsChecked
};

//# sourceMappingURL=definition-viewer.js.map